import { Box } from '@uhg-abyss/web/ui/Box';
import { IconBrand } from '@uhg-abyss/web/ui/IconBrand';
import { Grid } from '@uhg-abyss/web/ui/Grid';
import { Heading } from '@uhg-abyss/web/ui/Heading';

export const NoBenefitResultsModal = () => {
  return (
    <div style={{ margin: '100px' }}>
      <Grid.Col span={{ xs: 12, md: 4, lg: 4 }}>
        <Box padding="$lg" align="center" color="$white">
          <IconBrand
            icon="alert"
            color="$primary1"
            color2="$secondary2"
            size={100}
          />
          <Heading display="h6" offset={5} data-cy="main-heading">
            It's not you, it's us. Please try again later
          </Heading>
        </Box>
      </Grid.Col>
    </div>
  );
};
